import { useEffect, useState } from "react";
import type { AuditLog } from "@qbanq/shared";
import { api } from "../api/client";

export function AuditLogPage() {
  const [rows, setRows] = useState<AuditLog[]>([]);

  useEffect(() => {
    void api.get<AuditLog[]>("/api/audit?limit=200").then(setRows);
  }, []);

  return (
    <div>
      <h2>Audit Log</h2>
      <p className="muted">Every admin action and notable system event is recorded here.</p>
      <div className="card">
        <table>
          <thead>
            <tr><th>When</th><th>Action</th><th>Entity</th><th>Actor</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{new Date(r.created_at).toLocaleString()}</td>
                <td>{r.action}</td>
                <td className="muted">{r.entity_type}{r.entity_id ? `:${r.entity_id.slice(0, 8)}` : ""}</td>
                <td className="muted">{r.actor_user_id ? r.actor_user_id.slice(0, 8) : "system"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
